import { Tooltip } from "ant-design-vue";
import { defineAsyncComponent } from "vue";
import { createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { callUserOperatorType } from "../../../account/register/register.section";
import { callUserRequestStatus } from "../mgt-tab/tab-4/tab4.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.company.user"),
            dataIndex: "companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refPersonType?.key === "1" ? `${record.fullNameTh} ${record.idCard}` : `${record.fullNameTh} ${record.idCard}`,
            customRender: ({ record }) => {
                if (record.refPersonType?.key === "1") {
                    return (
                        <div>
                            <span>
                                {record.fullNameTh} {record.idCard}
                            </span>
                            <span class="ml-2">
                                <Tooltip title={record.refPersonType?.value}>
                                    <CIcon file="company.svg"></CIcon>
                                </Tooltip>
                            </span>
                            <span class="ml-2">
                                <Tooltip title={record.request["1"][0]?.refStatus.value}>
                                    <CIcon
                                        file={`${record.request["1"][0]?.refStatus.key}.svg`}
                                        class={{
                                            "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["1"][0]?.refStatus.key),
                                            "text-warning": record.request["1"][0]?.refStatus.key === "reEdit",
                                            "text-success": record.request["1"][0]?.refStatus.key === "approve"
                                        }}
                                    ></CIcon>
                                </Tooltip>
                            </span>
                        </div>
                    );
                } else if (record.refPersonType?.key === "2") {
                    return (
                        <div>
                            <span>
                                {record.fullNameTh} {record.idCard}
                            </span>
                            <span class="ml-2">
                                <Tooltip title={record.refPersonType?.value}>
                                    <CIcon file="person.svg"></CIcon>
                                </Tooltip>
                            </span>
                            <span class="ml-2">
                                <Tooltip title={record.request["1"][0]?.refStatus.value}>
                                    <CIcon
                                        file={`${record.request["1"][0]?.refStatus.key}.svg`}
                                        class={{
                                            "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["1"][0]?.refStatus.key),
                                            "text-warning": record.request["1"][0]?.refStatus.key === "reEdit",
                                            "text-success": record.request["1"][0]?.refStatus.key === "approve"
                                        }}
                                    ></CIcon>
                                </Tooltip>
                            </span>
                        </div>
                    );
                }
                return <div></div>;
            }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.userOperatorType.modelName"),
            dataIndex: "userOperatorTypes.refOperatorType.value",
            dataIndexValue: ({ record }) => record.userOperatorTypes.map(d => d.refOperatorType.value).join(", "),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callUserOperatorType, optLabel: "value", mode: "multiple" }),
            search: { name: "userOperatorTypes.refOperatorType.id", operator: "in", getValue: ({ value }) => value.map(d => d.id) },
            align: "center",
            width: 170
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.2.title"),
            dataIndex: "request.2.0.refStatus.value",
            customRender: ({ record }) => {
                if (!record.request["2"][0]?.refStatus) {
                    return <div></div>;
                }
                return (
                    <Tooltip title={record.request["2"][0]?.refStatus.value}>
                        <CIcon
                            file={`${record.request["2"][0]?.refStatus.key}.svg`}
                            class={{
                                "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["2"][0]?.refStatus.key),
                                "text-warning": record.request["2"][0]?.refStatus.key === "reEdit",
                                "text-success": record.request["2"][0]?.refStatus.key === "approve"
                            }}
                        ></CIcon>
                    </Tooltip>
                );
            },
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.3.title"),
            dataIndex: "request.3.0.refStatus.value",
            customRender: ({ record }) => {
                if (!record.request["3"][0]?.refStatus) {
                    return <div></div>;
                }
                return (
                    <Tooltip title={record.request["3"][0]?.refStatus.value}>
                        <CIcon
                            file={`${record.request["3"][0]?.refStatus.key}.svg`}
                            class={{
                                "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["3"][0]?.refStatus.key),
                                "text-warning": record.request["3"][0]?.refStatus.key === "reEdit",
                                "text-success": record.request["3"][0]?.refStatus.key === "approve"
                            }}
                        ></CIcon>
                    </Tooltip>
                );
            },
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.4.title"),
            dataIndex: "request.4.0.refStatus.value",
            customRender: ({ record }) => {
                if (!record.request["4"][0]?.refStatus) {
                    return <div></div>;
                }
                return (
                    <Tooltip title={record.request["4"][0]?.refStatus.value}>
                        <CIcon
                            file={`${record.request["4"][0]?.refStatus.key}.svg`}
                            class={{
                                "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["4"][0]?.refStatus.key),
                                "text-warning": record.request["4"][0]?.refStatus.key === "reEdit",
                                "text-success": record.request["4"][0]?.refStatus.key === "approve"
                            }}
                        ></CIcon>
                    </Tooltip>
                );
            },
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.5.title"),
            dataIndex: "request.5.0.refStatus.value",
            customRender: ({ record }) => {
                if (!record.request["5"][0]?.refStatus) {
                    return <div></div>;
                }
                return (
                    <Tooltip title={record.request["5"][0]?.refStatus.value}>
                        <CIcon
                            file={`${record.request["5"][0]?.refStatus.key}.svg`}
                            class={{
                                "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["5"][0]?.refStatus.key),
                                "text-warning": record.request["5"][0]?.refStatus.key === "reEdit",
                                "text-success": record.request["5"][0]?.refStatus.key === "approve"
                            }}
                        ></CIcon>
                    </Tooltip>
                );
            },
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.company.mgt.tab.6.title"),
            dataIndex: "request.6.0.refStatus.value",
            customRender: ({ record }) => {
                if (!record.request["6"][0]?.refStatus) {
                    return <div></div>;
                }
                return (
                    <Tooltip title={record.request["6"][0]?.refStatus.value}>
                        <CIcon
                            file={`${record.request["6"][0]?.refStatus.key}.svg`}
                            class={{
                                "text-danger": ["draft", "cancel", "notApprove"].includes(record.request["6"][0]?.refStatus.key),
                                "text-warning": record.request["6"][0]?.refStatus.key === "reEdit",
                                "text-success": record.request["6"][0]?.refStatus.key === "approve"
                            }}
                        ></CIcon>
                    </Tooltip>
                );
            },
            align: "center",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refStatus"),
            dataIndex: "refStatus.value",
            dataIndexValue: ({ record }) => {
                const request = Object.keys(record.request)
                    .map(key => record.request[key])
                    .filter(d => (d?.[0]?.refStatus?.seq || 0) > 0)
                    .sort((o1, o2) => o1[0].refStatus.seq - o2[0].refStatus.seq)?.[0]?.[0];
                return request?.refStatus.value;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            inputProp: () => ({ list: callUserRequestStatus, optLabel: "value" }),
            align: "center",
            sorter: false,
            search: {
                name: "refStatus.id",
                type: "Subquery",
                operator: "exists",
                getValue: ({ value }) =>
                    JSON.stringify({
                        clazz: "UserRequest",
                        where: [
                            { name: "refOwner.id", type: "GetpathParent", operator: "=", value: "id" },
                            { name: "refStatus.id", type: "UUID", operator: "=", value: value.id }
                        ]
                    })
            }
        })
    ];
    return columns;
};
